import { Modal } from 'hljd'

export const cantUse = () => {
  Modal.info({
    title: '该功能当前暂无法使用',
    content: '上线后我们将在第一时间通知到您。'
  })
}
